export function postMessage(path) {
    let {
        origin,
        pathname
    } = location
    let postPath = origin + pathname + '#' + path
    parent.postMessage(postPath, '*')
    return postPath
}